import { getObLocale } from '../utils/obLocales';

export const featuresConfigs = {
  '@feature/account-preferences': () => ({}),
  '@feature/account-info': () => ({}),
  '@feature/live-chat-flow': ({
    productConfig,
    chatButtonName,
    chatEnvironment,
    chatIssuer,
    chatAuthFunction,
    syncAudiences,
    autoStart,
    initDelay,
  }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    chatButtonName: chatButtonName,
    client: {
      environment: chatEnvironment,
      issuer: chatIssuer,
      authFunctionProperty: chatAuthFunction,
      syncAudiences: typeof syncAudiences === 'undefined' ? true : syncAudiences,
      autoStart: typeof autoStart === 'undefined' ? true : syncAudiences,
    },
    initDelay,
  }),

  '@feature/account-flags': ({ productConfig, deviceType }) => ({
    jurisdiction: productConfig.jurisdiction,
    isMobileDevice: deviceType === 'mobile',
  }),

  '@feature/account-flags-flow': ({ productConfig, locale }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    locale,
  }),

  '@feature/promotions-flow': ({
    productConfig,
    supportedLangCodes,
    defaultLangCode,
    helpPageUrls,
    routingStrategy,
    vertical,
    routes,
    gameLauncher,
  }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    supportedLangCodes,
    defaultLangCode,
    helpPageUrls,
    routingStrategy,
    vertical,
    routes,
    gameLauncher,
  }),

  '@feature/apollo-data-access-service': ({ productConfig, vertical }) => ({
    url: productConfig.graphqlUrl,
    authorizationMode: 'SessionContainerInternalToken',
    headers: ['vertical'],
    predefinedHeaders: { vertical },
  }),

  '@feature/account-actions': ({ productConfig, locale, productSource, isMobile, dcf }) => ({
    language: locale,
    jurisdiction: productConfig.jurisdiction,
    env: productConfig.env,
    regSource: productSource,
    isMobile,
    dcf,
  }),

  '@feature/cas-session-manager': ({ productConfig, vertical }) => ({
    casUrl: productConfig.casUrl,
    sessionLogoutListener: {
      url: productConfig.sessionListenerUrl,
      heartbeatTimeout: 60 * 60 * 1000,
    },
    sessionMarkActive: {
      iamAliveDebounceTime: 60 * 1000,
      iamAliveDebounceMaxWaitTime: 5 * 60 * 1000,
      retryMaxTime: 10 * 1000,
      retryInterval: 2 * 1000,
    },
    enableFlagHandling: productConfig.enableFlagHandling,
    enableRecaptcha: productConfig.enableRecaptcha,
    ...((vertical === 'sportsbook' || vertical === 'sportsbook-native') && productConfig.jurisdiction === 'com'
      ? {
          sessionPassiveLoginListener: {
            strategy: 'native',
          },
        }
      : {}),
  }),

  '@feature/session-service': ({ productConfig }) => ({
    sessionServiceUrl: productConfig.sessionContainerUrl,
  }),

  '@feature/web-login-preferences': ({ productConfig }) => ({
    casUrl: productConfig.casUrl,
    serviceUrl: `${productConfig.sessionListenerUrl}/logout`,
    enableFlagHandling: productConfig.enableFlagHandling,
    enableRecaptcha: productConfig.enableRecaptcha,
  }),

  '@feature/login-flow': ({ productConfig, locale }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    locale: locale,
  }),

  '@feature/myaccount': ({ productConfig, locale, translations, vertical }) => ({
    jurisdiction: productConfig.jurisdiction,
    langCode: locale,
    vertical,
    translations,
  }),

  '@feature/dcf-flow': ({
    productConfig,
    locale,
    registrationCardCreatorUrl,
    tdsTermUrl,
    tdsTermUrlV2,
    loadingBundleTimeout,
    productSource,
  }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    languageCode: locale,
    configVersion: 'valid',
    cardCreatorUrl: registrationCardCreatorUrl,
    tdsTermUrl: tdsTermUrl,
    tdsTermUrlV2: tdsTermUrlV2,
    loadingBundleTimeout: loadingBundleTimeout,
    productSource,
  }),

  '@feature/safer-gambling-modals': ({ translations }) => ({
    translations,
  }),

  '@feature/recaptcha-service': ({ siteKey }) => ({
    siteKey,
  }),

  '@feature/registration-flow': ({ productConfig, locale, productSource, engagementName, isLivePersonSupported }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    locale: locale,
    regSource: productSource,
    engagementName,
    isLivePersonSupported,
  }),

  '@feature/obsession-service': ({ productConfig, locale }) => ({
    obSessionServiceUrl: `${productConfig.OBSessionServiceBaseUrl}/${getObLocale(locale)}`,
    casUrl: productConfig.casUrl,
  }),

  '@feature/hidden-markets-widget-flow': ({ productConfig, locale }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    locale: locale,
  }),

  '@feature/promotions-banners-flow': ({ productConfig, locale, vertical }) => ({
    environment: productConfig.env,
    jurisdiction: productConfig.jurisdiction,
    locale,
    vertical,
  }),

  '@feature/smart-banners-flow': ({ pbaKey, webKey, autostart, initDelayMs, bannerZIndex, bannerContainerQuery }) => ({
    pbaKey,
    webKey,
    autostart,
    initDelayMs,
    bannerZIndex,
    bannerContainerQuery,
  }),
};
